import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import Wave2 from "../../../images/modalWave2.svg";

interface DeleteSGModalProps {
    sgName?: string;
    sgId?: number;
    isOpen: boolean;
    onDelete: (id: number) => Promise<void>;
    onClose: () => void;
    resetValues: () => void;
}

const DeleteSGModal = (props: DeleteSGModalProps) => {

    const handleDelete = (): void => {
        props.onDelete(props.sgId).then(() => {
            props.onClose();
            props.resetValues();
        });
    };

    const handleCancelBtn = (): void => {
        props.onClose();
        props.resetValues();
    };

    return (
        <Modal
            open={props.isOpen}
            className="confirm-delete-modal"
            size="tiny"
            centered={true}
        >
            <Modal.Header>Are you sure want to delete?</Modal.Header>
            <Modal.Content>
                <p><i>Spreading Grounds:</i>  <b>{props.sgName}</b></p>
            </Modal.Content>
            <Modal.Actions>
                <div className="wave-div">
                    <img src={Wave2} alt="wave" className="wave" />
                </div>
                <div style={{ padding: "1em" }}>
                    <Button color="red" onClick={handleDelete}>
                        Delete
                    </Button>
                    <Button onClick={handleCancelBtn}>
                        Cancel
                    </Button>
                </div>
            </Modal.Actions>
        </Modal>
    );
};

export default DeleteSGModal;
